import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { IAreaModel } from 'models/area.model'

export const GET_AREAS_LIST = 'GET_AREAS_LIST'
export const GET_AREAS_LIST_SUCCESS = 'GET_AREAS_LIST_SUCCESS'

export const Actions = {
  getAreasList: () => createAction(GET_AREAS_LIST),
  getAreasListSuccess: (payload: IAreaModel[]) => createAction(GET_AREAS_LIST_SUCCESS, payload),
}

export type Actions = ActionsUnion<typeof Actions>
